/*****************************************************
 *  CoCoCreate – Flourish Collage + Layout Receiver
 *  This file listens for messages from the Library
 *  and injects the selected collage HTML + CSS.
 *****************************************************/

/* -----------------------------
   Listen for messages from Library
------------------------------ */
window.addEventListener("message", (event) => {
  const data = event.data;
  if (!data || data.tipo !== "applyCollageLayout") return;

  console.log("📥 Flourish received collage payload:", data.payload);

  if (typeof window.applyCollageLayout === "function") {
    window.applyCollageLayout(data.payload);
  } else {
    console.warn("⚠️ applyCollageLayout exists but did not run.");
  }
});


/* -----------------------------
   Main handler to apply collage
------------------------------ */
// ============================================================
// CoCoCreate → Flourish Workspace Collage/Layout Loader
// ============================================================
(function () {
  // Ensure function registers only after DOM is ready
  document.addEventListener("DOMContentLoaded", () => {
    
    window.applyCollageLayout = function ({ title, fileUrl, html, css }) {
      try {
        console.log("🎨 [Flourish] Applying collage:", title);

        // -------------------------------
        // 1. Inject HTML into the board
        // -------------------------------
        const board = document.getElementById("board");
        if (!board) {
          console.warn("⚠️ [Flourish] #board not found — collage skipped.");
        } else {
          board.innerHTML = html;
        }

        // -------------------------------
        // 2. Inject accompanying CSS
        // -------------------------------
        if (css) {
          const tag = document.createElement("style");
          tag.textContent = css;
          tag.dataset.cocoCollage = title.toLowerCase().replace(/\s+/g, "-"); 
          document.head.appendChild(tag);
        }

        // -------------------------------
        // 3. Update on-screen label (optional)
        // -------------------------------
        const banner = document.getElementById("currentTemplateName");
        if (banner) banner.textContent = title;

        // -------------------------------
        // 4. Reopen Builder Panel (if exists)
        // -------------------------------
        if (typeof window.openBuilderPanel === "function") {
          window.openBuilderPanel();
        }

        console.log("✅ [Flourish] Collage applied successfully.");

      } catch (err) {
        console.error("❌ [Flourish] Failed to apply collage:", err);
      }
    };

    console.log("✅ window.applyCollageLayout registered.");
  });
})();


/* -----------------------------
   Optional: Seed handoff support
   (kept from original Flourish loader)
------------------------------ */
(function () {
  try {
    const tiles = JSON.parse(localStorage.getItem("coco_flourish_seed_tiles") || "[]");
    const title = localStorage.getItem("coco_flourish_seed_title") || "";

    if (tiles.length) {
      window.cocoSeedPreset = { title, tiles };
      localStorage.removeItem("coco_flourish_seed_tiles");
      localStorage.removeItem("coco_flourish_seed_title");
    }
  } catch (_) {}
})();
